<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!-- Main content Start -->
<div class="main-content">
  <!-- Breadcrumbs Start -->
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Management</h1>
      <ul>
        <li>
          <a class="active" href="/">Home</a>
        </li>
        <li>
          <a>About</a>
        </li>
        <li>Management</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumbs End -->
  <!-- Blog Section Start -->
  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <about-menu></about-menu>
        </div>
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-12 mb-70" *ngFor="let profile of managementProfiles(); trackBy: trackById">
              <div class="blog-item">
                <div class="blog-img">
                  <a href="#"><img [src]="profile.image" [alt]="profile.name"></a>
                </div>
                <div class="blog-content">
                  <h3 class="blog-title">{{ profile.name }}</h3>
                  <div class="blog-meta">
                    <ul class="btm-cate">
                      <li>
                        <div class="author">
                          <i class="fa fa-user-o"></i> {{ profile.designation }}
                        </div>
                      </li>
                      <li *ngIf="profile.institution">
                        <div class="tag-line">
                          <i class="fa fa-university"></i> {{ profile.institution }}
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="blog-desc management-desc" *ngFor="let description of profile.descriptions">
                    {{ description }}
                  </div>
                  <div class="blog-button">
                    <a class="blog-btn" [routerLink]="profile.route" routerLinkActive="active">Continue Reading</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Blog Section End -->
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

